import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/text-area/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p><inlineCode parentName="p">{`TextArea`}</inlineCode>{` is a multiline, editable text input control with a lot of customisation options.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let textArea = TextArea()
`}</code></pre>
    <h2>{`Properties`}</h2>
    <h4>{`text`}</h4>
    <p>{`The text that’s shown by the control.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textarea_text.png",
        "alt": "Text TextArea"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.text = "This is a simple text that can cover multiple lines if the control is too small to fit everything on one line."
`}</code></pre>
    <h4>{`placeholder`}</h4>
    <p>{`The placeholder text that’s shown when no text has been entered. Placeholder text is shown in a light gray color.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textarea_placeholder.png",
        "alt": "Placeholder TextArea"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.placeholder = "Type something..."
`}</code></pre>
    <h4>{`hasError`}</h4>
    <p>{`If true, the control will be red. Use this property if something’s wrong and the text area control needs a user’s attention.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textarea_error.png",
        "alt": "Error TextArea"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.hasError = true
`}</code></pre>
    <h4>{`isEnabled`}</h4>
    <p>{`If false, the control will not react to user interaction and will have a light gray color.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textarea_disabled.png",
        "alt": "Disabled TextArea"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.isEnabled = false
`}</code></pre>
    <h4>{`isHighlighted`}</h4>
    <p>{`If true, the control has a blue border.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/ios/textarea_highlighted.png",
        "alt": "Highlighted TextArea"
      }}></img></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.isHighlighted = true
`}</code></pre>
    <h4>{`inputView`}</h4>
    <p>{`The custom input view to display when the receiver becomes the first responder. The default value is nil, resulting in the system-supplied keyboard to be used.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.inputView = customView
`}</code></pre>
    <h4>{`inputAccessoryView`}</h4>
    <p>{`An accessory view for to the system-supplied keyboard or the custom input view.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.inputAccessoryView = customAccessoryView
`}</code></pre>
    <h4>{`keyboardType`}</h4>
    <p>{`The specific keyboard that should be used for this control.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.keyboardType = .numberPad
`}</code></pre>
    <h4>{`keyboardAppearance`}</h4>
    <p>{`The appearance style of the keyboard.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.keyboardAppearance = .dark
`}</code></pre>
    <h4>{`returnKeyType`}</h4>
    <p>{`The visible title of the return key.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.returnKeyType = .done
`}</code></pre>
    <h4>{`textContentType`}</h4>
    <p>{`The semantic meaning of the control.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.textContentType = .emailAddress
`}</code></pre>
    <h4>{`isSecureTextEntry`}</h4>
    <p>{`If true, disables the user’s ability to copy the text.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.isSecureTextEntry = true
`}</code></pre>
    <h4>{`enablesReturnKeyAutomatically`}</h4>
    <p>{`If true, the keyboard disables the Return key when the text entry area contains no text. As soon as the user enters some text, the Return key is automatically enabled.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.enablesReturnKeyAutomatically = true
`}</code></pre>
    <h4>{`autocapitalizationType`}</h4>
    <p>{`The autocapitalization style of the control.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.autocapitalizationType = .sentences
`}</code></pre>
    <h4>{`autocorrectionType`}</h4>
    <p>{`The autocorrection behavior of the control.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.autocorrectionType = .yes
`}</code></pre>
    <h4>{`spellCheckingType`}</h4>
    <p>{`The spell-checking style of the control.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.spellCheckingType = .no
`}</code></pre>
    <h4>{`smartQuotesType`}</h4>
    <p>{`The configuration state for smart quotes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.smartQuotesType = .yes
`}</code></pre>
    <h4>{`smartDashesType`}</h4>
    <p>{`The configuration state for smart dashes.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.smartDashesType = .yes
`}</code></pre>
    <h4>{`smartInsertDeleteType`}</h4>
    <p>{`The configuration state for the smart insertion and deletion of space characters.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`textInput.smartInsertDeleteType = .yes
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      